import { render, staticRenderFns } from "./AccessCompact.vue?vue&type=template&id=5796087b&scoped=true&"
import script from "./AccessCompact.vue?vue&type=script&lang=js&"
export * from "./AccessCompact.vue?vue&type=script&lang=js&"
import style0 from "./AccessCompact.vue?vue&type=style&index=0&id=5796087b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5796087b",
  null
  
)

export default component.exports